import { render, staticRenderFns } from "./CmsSafeCheck.vue?vue&type=template&id=67192260&scoped=true&"
import script from "./CmsSafeCheck.vue?vue&type=script&lang=js&"
export * from "./CmsSafeCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67192260",
  null
  
)

export default component.exports